import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getAuditFlows = () => call(websocketFetch, 'get_audit_flows');
